import React from "react"
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { SelfCheckinStepEnum, SelfBoardingStepEnum } from "components/shared/enums/global-enums.tsx";
import Initial from "./Initial/Initial"
import Message from "./Message/Message"
import BagsCount from "./BagsCount/BagsCount"
import PrintChoices from "./PrintChoices/PrintChoices"
import './Actions.scss'

export default function Actions({sCC, index, gTypeFor, airline}){

  let component;

  if (gTypeFor === SelfBoardingStepEnum.PASSENGER_BOARDING){
    component = <Message messageText={"WELCOME ABOARD!"} />;
  }else{
    
    if (gTypeFor !== SelfCheckinStepEnum.ITEMS_TO_PRINT){
      if  (sCC.typeFor === SelfCheckinStepEnum.PASSENGER){
        component = <Initial sCC={sCC} index={index} />;
      } else if (sCC.typeFor === SelfCheckinStepEnum.SELECT_BAGS) {
        component = <BagsCount airline={airline} sCC={sCC} index={index} />;
      }
    } else {
      component =<PrintChoices sCC={sCC} index={index}/>;
    }
  }

  return (
    <>
      <Box className="actions-container">
        <Grid  container className={`d-f fd-c`}>
          {component}
        </Grid>
      </Box>
    </>
    )
}
